import React, { useState } from 'react';
import { Breadcrumb } from '../components/common/Breadcrumb';
import { SimulatorTabs } from '../components/simulator/SimulatorTabs';
import { GeneralInfo } from '../components/simulator/GeneralInfo';
import { DebtDetails } from '../components/simulator/DebtDetails';
import { PreviousManagement } from '../components/simulator/PreviousManagement';
import { NegotiationSimulator } from '../components/simulator/NegotiationSimulator';
import { NegotiationRegister } from '../components/simulator/NegotiationRegister';
const breadcrumbItems = [{
  label: 'Comercial',
  href: '#'
}, {
  label: 'Simulador Financiero'
}];
const tabs = [{
  id: 'general',
  label: 'Información General'
}, {
  id: 'debt',
  label: 'Detalle Deuda'
}, {
  id: 'previous',
  label: 'Gestiones Anteriores'
}, {
  id: 'simulation',
  label: 'Simulación Negociación'
}, {
  id: 'register',
  label: 'Negociación y Registro'
}];
export const FinancialSimulator = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [simulationData, setSimulationData] = useState(null);
  const handleSimulationComplete = data => {
    setSimulationData(data);
    setActiveTab('register');
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1420">
      <main className="pt-16 pl-64" data-id="element-1421">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1422">
          <div className="mb-6" data-id="element-1423">
            <Breadcrumb items={breadcrumbItems} data-id="element-1424" />
            <div className="flex justify-between items-center mt-4" data-id="element-1425">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1426">
                Simulador Financiero
              </h1>
              <div className="flex items-center space-x-2" data-id="element-1427">
                <span className="text-sm font-medium text-gray-500" data-id="element-1428">
                  Cliente:
                </span>
                <span className="text-sm font-bold" data-id="element-1429">Juan Pérez Gómez</span>
                <span className="mx-2 text-gray-300" data-id="element-1430">|</span>
                <span className="text-sm font-medium text-gray-500" data-id="element-1431">ID:</span>
                <span className="text-sm font-bold" data-id="element-1432">12345678</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow" data-id="element-1433">
            <SimulatorTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} data-id="element-1434" />
            <div className="p-6" data-id="element-1435">
              {activeTab === 'general' && <GeneralInfo data-id="element-1436" />}
              {activeTab === 'debt' && <DebtDetails data-id="element-1437" />}
              {activeTab === 'previous' && <PreviousManagement data-id="element-1438" />}
              {activeTab === 'simulation' && <NegotiationSimulator onSimulationComplete={handleSimulationComplete} data-id="element-1439" />}
              {activeTab === 'register' && <NegotiationRegister simulationData={simulationData} data-id="element-1440" />}
            </div>
          </div>
        </div>
      </main>
    </div>;
};